import React, { useState, useEffect } from 'react';
import ItemProgressBar from '../../../../../../shared/ItemProgressBar';
import { MilestoneMarker } from '../../icons';
import { MilestonePathIcon } from '../../../MilestonePathModal/MilestonePathIcon';
import { openMilestonePathModal } from '../../../../utils/openMilestonePathModal';
import MilestoneCompletionCheck from '../../components/MilestoneCompletionCheck';

/**
 * Single milestone with progress bar.
 */
const MilestoneItem = ({
  entry,
  onGoToTask,
  onMouseEnter,
  onMouseLeave,
  celebrationPhase = null,
}) => {
  const { milestone, progressPercent, reached } = entry;
  const name = milestone.name || 'Untitled';
  const isCelebrating = Boolean(celebrationPhase);
  const [animProgress, setAnimProgress] = useState(progressPercent);

  useEffect(() => {
    if (celebrationPhase === 'fill') {
      setAnimProgress(progressPercent);
      const frame = requestAnimationFrame(() => {
        requestAnimationFrame(() => setAnimProgress(100));
      });
      return () => cancelAnimationFrame(frame);
    }
    if (celebrationPhase === 'check' || celebrationPhase === 'exit') {
      setAnimProgress(100);
    }
    return undefined;
  }, [celebrationPhase, progressPercent]);

  const displayProgress = isCelebrating ? animProgress : progressPercent;
  const isComplete = reached || celebrationPhase === 'check' || celebrationPhase === 'exit';
  const showCheck = celebrationPhase === 'check' || celebrationPhase === 'exit';

  const handleOpenPath = (e) => {
    e.stopPropagation();
    openMilestonePathModal(milestone.id);
  };

  return (
    <div
      className={[
        'flowchart-hud__mission-item',
        'flowchart-hud__mission-item--milestone',
        isComplete && 'flowchart-hud__mission-item--milestone-reached',
        isCelebrating && 'flowchart-hud__mission-item--milestone-celebrating',
        celebrationPhase === 'check' && 'flowchart-hud__mission-item--milestone-pop',
      ].filter(Boolean).join(' ')}
      onClick={isCelebrating ? undefined : () => onGoToTask?.(milestone.id)}
      onMouseEnter={isCelebrating ? undefined : onMouseEnter}
      onMouseLeave={isCelebrating ? undefined : onMouseLeave}
    >
      <div className="flowchart-hud__milestone-item-row">
        <span className="flowchart-hud__milestone-icon-container">
          <MilestoneMarker
            size={16}
            className="flowchart-hud__milestone-icon--small"
            reached={isComplete}
          />
        </span>
        <div className="flowchart-hud__milestone-item-content">
          <div className="flowchart-hud__milestone-label-row">
            <span className="flowchart-hud__milestone-label">{name}</span>
            {!isCelebrating && (
              <span className="flowchart-hud__milestone-item-actions">
                <button
                  type="button"
                  className="flowchart-hud__milestone-path-btn"
                  title="View path to milestone"
                  aria-label="View path to milestone"
                  onClick={handleOpenPath}
                >
                  <MilestonePathIcon size={13} />
                </button>
              </span>
            )}
          </div>
          <ItemProgressBar
            progress={displayProgress}
            complete={isComplete}
            className={celebrationPhase === 'fill' ? 'item-progress-bar--celebrate-fill' : ''}
          />
        </div>
      </div>
      {showCheck && (
        <div className="flowchart-hud__milestone-check-overlay" aria-hidden="true">
          <MilestoneCompletionCheck size={24} />
        </div>
      )}
    </div>
  );
};

export default MilestoneItem;
